import React, { useRef, useState } from 'react'
import { Button, Table } from 'components'
import template from './newVouchers.csv'
import styles from './VouchersTable.module.scss'

const CustomHeaderRight = ({
    addNewVouchers,
    currentStep,
    handleFileUpload,
    setCurrentStep,
    setIsModalOpen,
    setUploadedCsvData,
    uploadedCsvData,
}) => {
    const fileUploadInput = useRef(null)
    const onCancel = () => {
        setIsModalOpen(false)
        setCurrentStep(1)
        setUploadedCsvData([])
    }

    return (
        <div className={styles.CustomHeaderRight}>
            <a href={template} className="modal-table-button-upload-csv" target="_blank" download="newVouchers" rel="noopener noreferrer">
                <Button {...{ className: styles.stepButton, onClick: () => setTimeout(() => setCurrentStep(2), 1000), variant: 'primary' }}>
                    Step 1. Click here to download template and add one voucher code per line
                </Button>
            </a>

            <div className={styles.buttonBlock}>
                <Button
                    {...{
                        className: styles.stepButton,
                        disabled: currentStep < 2,
                        onClick: () => fileUploadInput.current.click(),
                        variant: 'primary',
                    }}
                >
                    Step 2. Click here to reupload the modified CSV
                </Button>
                <input
                    accept=".csv"
                    disabled={currentStep < 2}
                    id="filePicker"
                    ref={fileUploadInput}
                    style={{ display: 'none' }}
                    type="file"
                    value="" // Without this, the file cannot be uploaded more than once
                    onChange={e => handleFileUpload({ e, callback: () => setCurrentStep(3) })}
                />
            </div>

            <Button {...{ disabled: uploadedCsvData.length === 0, onClick: addNewVouchers, variant: 'primary' }}>Step 3. Confirm</Button>
            <Button {...{ onClick: onCancel, variant: 'outlined' }}>Cancel</Button>
        </div>
    )
}

export const UploadNewVouchers = ({ addNewVouchers, columns, handleFileUpload, setIsModalOpen, setUploadedCsvData, uploadedCsvData }) => {
    const [currentStep, setCurrentStep] = useState(1)

    return (
        <div>
            <Table
                tableClassName={styles.UploadNewVouchersTable}
                title="Add New Vouchers"
                data={uploadedCsvData}
                columns={columns}
                renderCustomHeaderRight={() => (
                    <CustomHeaderRight
                        {...{ addNewVouchers, currentStep, handleFileUpload, setCurrentStep, setIsModalOpen, setUploadedCsvData, uploadedCsvData }}
                    />
                )}
            />
        </div>
    )
}
